import { useEffect, useRef } from 'react';
import { trackEvent } from 'src/utils/analytics';

// Fires a `form_abandoned` event if the user leaves the page while the form
// is dirty and markCompleted() was never called (i.e. they didn't finish a
// successful submit). Refs avoid stale closures in the beforeunload listener
// without re-registering it on every render.
export function useFormAbandonmentTracking(formName, section, isDirty) {
  const sectionRef = useRef(section);
  const isDirtyRef = useRef(isDirty);
  const completedRef = useRef(false);

  useEffect(() => {
    sectionRef.current = section;
  }, [section]);
  useEffect(() => {
    isDirtyRef.current = isDirty;
  }, [isDirty]);

  const markCompleted = () => {
    completedRef.current = true;
  };

  useEffect(() => {
    const handleBeforeUnload = () => {
      if (completedRef.current || !isDirtyRef.current) return;
      trackEvent('form_abandoned', formName, sectionRef.current || 'unknown');
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [formName]);

  return { markCompleted };
}
